import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateCalendarModality($data: UpdateCalendarModalityInput!) {
    updateCalendarModality(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateCalendarModality: {
    id: number;
  };
}
